import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

// Данные о производстве продукции по регионам
const dataSource = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
      Молоко: 406417,
      Шерсть: 1049,
      Яйца: 355766,
      Мясо: 78142,
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
      Молоко: 58823,
      Шерсть: 124,
      Яйца: 10768,
      Мясо: 22238,
    },
  },
  {
    key: 2,
    region: "Ошская",
    counts: {
      Молоко: 234977,
      Шерсть: 419,
      Яйца: 45247,
      Мясо: 42292,
    },
  },
  {
    key: 3,
    region: "Таласская",
    counts: {
      Молоко: 60928,
      Шерсть: 738,
      Яйца: 14146,
      Мясо: 18107,
    },
  },
  {
    key: 4,
    region: "Нарынская",
    counts: {
      Молоко: 107012,
      Шерсть: 1541,
      Яйца: 3634,
      Мясо: 34799,
    },
  },
  {
    key: 5,
    region: "Ыссык-Кульская",
    counts: {
      Молоко: 184492,
      Шерсть: 1745,
      Яйца: 23274,
      Мясо: 44368,
    },
  },
  {
    key: 6,
    region: "Джалал-Абадская",
    counts: {
      Молоко: 107012,
      Шерсть: 37,
      Яйца: 47790,
      Мясо: 49689,
    },
  },
];

// Преобразование данных для Recharts
const chartData = dataSource.map((data) => ({
  region: data.region,
  Молоко: data.counts.Молоко,
  Шерсть: data.counts.Шерсть,
  Яйца: data.counts.Яйца,
  Мясо: data.counts.Мясо,
}));

const ProductAnimalChart = () => {
  return (
    <div style={{ width: '90%', height: 500, margin: '0 auto' }}>
      <h2>Производство продукции по регионам</h2>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="region" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Молоко" fill="#8884d8" name="Молоко" />
          <Bar dataKey="Шерсть" fill="#82ca9d" name="Шерсть" />
          <Bar dataKey="Яйца" fill="#ffc658" name="Яйца" />
          <Bar dataKey="Мясо" fill="#ff8042" name="Мясо" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProductAnimalChart;
